import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment, TextFieldProps } from '@mui/material';

interface PhoneInputProps extends Omit<TextFieldProps, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, ...props }) => {
  const [displayValue, setDisplayValue] = useState('');
  
  // Format value for display (with mask)
  useEffect(() => {
    if (!value) {
      setDisplayValue('');
      return;
    }
    
    // Strip all non-digits and leading '+' if exists
    let digits = value.replace(/\D/g, '');
    
    // If there are digits and the value doesn't start with 7, prepend 7
    if (digits && !digits.startsWith('7')) {
      digits = '7' + digits;
    }
    
    // Apply mask: (XXX) XXX-XX-XX
    let result = '';
    if (digits.length > 0) {
      result += '(';
      result += digits.substring(1, 4); // Area code (skip country code)
      
      if (digits.length > 4) {
        result += ') ';
        result += digits.substring(4, 7); // First part
      }
      
      if (digits.length > 7) {
        result += '-';
        result += digits.substring(7, 9); // Second part
      }
      
      if (digits.length > 9) {
        result += '-';
        result += digits.substring(9, 11); // Last part
      }
    }
    
    setDisplayValue(result);
  }, [value]);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    
    // Strip all non-digits
    const digits = input.replace(/\D/g, '');
    
    // Create a normalized value for the model
    let newValue = '';
    if (digits) {
      newValue = '+7' + digits.substring(0, 10); // Limit to 10 digits (without country code)
    }
    
    onChange(newValue);
  };
  
  return (
    <TextField
      {...props}
      value={displayValue}
      onChange={handleChange}
      placeholder="(700) 123-45-67"
      inputMode="tel"
      type="tel"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">+7</InputAdornment>
        ),
        ...props.InputProps,
      }}
    />
  );
};

export default PhoneInput; 